import React from 'react';
import '../../Components/ContactForm/styles.scss'


const Home = ({ defaultContent }) => {
    return (
            <div className='message' dangerouslySetInnerHTML={{ __html: defaultContent }}></div>
    );
}

export default Home;
